import { type IPostTile, PostTile } from "@/src/blog/PostTile";
import { browserStatics } from "@/src/shared/BrowserStatic";
import { BlogPostMobile } from "@Routes/BlogLinks";

import * as css from "./Timeline.module.css";

export interface ITimeline {
    timeLimeList: IPostTile[];
}

export const Timeline = (props: ITimeline) => {
    const urlTemplate = browserStatics.isMobileApp
        ? BlogPostMobile
        : {
              url: "/blog/%7Bslug%7D/%7Bid%7D",
              type: undefined as { slug: string | number; id: string | number },
          };
    return (
        props &&
        props.timeLimeList && (
            <div className={css.timelineComponent}>
                {props.timeLimeList.map((value) => (
                    <div key={value.id} className={css.timeContent}>
                        <PostTile {...value} urlTemplate={urlTemplate} />
                        <div className={css.dateWrapper}>
                            <div className={css.date}>
                                <span className={css.day}>{value.dayOfPost}</span>
                                <span className={css.month}>{value.monthOfPost}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        )
    );
};
